export default {
    state: {
        tipos: [],
        subtipos: []
    },
    getters: {
        tipos: (state) => state.tipos,
        subtipos: (state) => state.subtipos,
    },
    mutations: {
        SET_TIPOS: (state, payload) => state.tipos = payload,
        SET_SUBTIPOS: (state, payload) => state.subtipos = payload,
    },
    actions: {
        fetchTipos({commit}) {
            this.dispatch('index', {endpoint: 'tipo_gestion'})
            .then(response => {
                commit('SET_TIPOS', response.datos)
            })
            .catch(error => {
                console.log(error)
            })
        },
        fetchSubTipos({commit}) {
            this.dispatch('index', {endpoint: 'subtipo_gestion', params: {paginar: false}},)
            .then(response => {
                commit('SET_SUBTIPOS', response.datos)
            })
            .catch(error => {
                console.log(error)
            })
        },
    }
}